import React from 'react';
import {createRoot} from 'react-dom/client';
import SimulatorForm from './components/SimulatorForm';
import './index.css';
import { TranslationsProvider } from './context/TranslationsProvider';
import { ALL_TRANSLATION_KEYS } from './utils/translationKeys';

const App = ({ configuration }) => {
    return (
      <TranslationsProvider configuration={configuration} keys={ALL_TRANSLATION_KEYS}>
        <SimulatorForm configuration={configuration} />
      </TranslationsProvider>
    );
  };

class WebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        const configuration={
            clientId: this.getAttribute('clientId'),
            clientSecret: this.getAttribute('clientSecret'),
            tokenUrl: this.getAttribute('tokenUrl'),
            companyPayrollSimulator: this.getAttribute('companyPayrollSimulator'),
            ratesSimulatorLibranza: this.getAttribute('ratesSimulatorLibranza'),
            deadlinesAmountofPayment: this.getAttribute('deadlinesAmountofPayment'),
            solicitudCreditoUrl: this.getAttribute('solicitudCreditoUrl'),
            solicitudAsesoriaUrl: this.getAttribute('solicitudAsesoriaUrl')
        };

        this.root.render(<App configuration={configuration} />, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}


const ELEMENT_ID = 'simulador-credito-libranza';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}
